import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { environment } from '../../../environments/environment';
import { UploadService } from './Upload.service';

@Injectable()
export class ContactService extends ApiEvsService {
  constructor(
    http: Http,
    router: Router,
    private uploadService: UploadService
  ) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/v2/contacts', query);
  }

  create(body: any) {
    return this.post('/v2/contact', body);
  }

  find(id) {
    return this.get('/contact/' + id);
  }

  update(id, body) {
    return this.put('/contact/' + id, body);
  }

  deleteContact(id) {
    return this.delete('/contact/' + id);
  }

  findByPhone(phone) {
    return this.get('/v2/find-by-phone/' + phone);
  }

  findByFacebook(fb_id) {
    return this.get('/contact-facebook/' + fb_id);
  }

  findInAll(query?: any) {
    return this.get('/find-user', query);
  }

  getFileImportContactExample() {
    return this.getexcel('/v2/contact/import/template', 'FileImportContactExample');
  }

  importContactWithFile(file, postData?: any) {
    return this.uploadService.postWithFile(environment.api_evs + '/v2/contact/import-with-file', file, postData);
  }
  exports(query: any, body: any) {
    return this.getexcel('/v2/contact/exports', 'DanhSachKhachHang', 'POST', query, body);
  }

  merges(body) {
    return this.post('/v2/contact/merges', body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Contact.service.ts